import './CartPage.scss';

import { b2x } from '@b2x/react/src';

import { Container } from '../Container';
import { t } from '../i18n/i18n';
import { Page } from './Page';

export type CartPageProps = b2x.CartPageProps;

export const CartPage = (props: CartPageProps) => {
  const { session } = b2x.useAppContext();

  return (
    <Page className="cart-page pt-3 pt-xl-5" noPaddingTop>
      <section className="mb-md-5 mb-3">
        <Container>
          <div className="text-center">
            <b2x.H1 alignItems={'center'} className="h3" display={'flex'} justifyContent={'center'} margin={0}>
              <b2x.Span className="h3 text-uppercase letter-spacing-md" fontWeight={700}>
                {t('cart.title')}
              </b2x.Span>
              {session?.cart?.itemsNumber !== undefined && session.cart.itemsNumber > 0 && (
                <b2x.Span className="h6 fw-light" dynamicMargin={{ start: 2 }}>
                  ({session.cart.itemsNumber})
                </b2x.Span>
              )}
            </b2x.H1>
          </div>
        </Container>
      </section>
      <b2x.CartPage {...props} />
    </Page>
  );
};
